/**
 *
 * Gallery
 *
 */

import React from "react"
import { map } from "lodash"
import { Modal, Tabs, Button } from "antd"
import { Icon } from "@ant-design/compatible"
import { CloseOutlined } from "@ant-design/icons"
// import checkBlue from 'images/full-check-blue.svg';
// import './index.less';

const { TabPane } = Tabs

const data = [
  {
    image:
      "https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    id: 1,
  },
  {
    image:
      "https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    id: 2,
  },
  {
    image:
      "https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    id: 3,
  },
  {
    image:
      "https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    id: 4,
  },
  {
    image:
      "https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    id: 6,
  },
  {
    image:
      "https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    id: 7,
  },
  {
    image:
      "https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    id: 8,
  },
  {
    image:
      "https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    id: 9,
  },
  {
    image:
      "https://images.pexels.com/photos/1619317/pexels-photo-1619317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    id: 10,
  },
]

/* eslint-disable react/prefer-stateless-function */
class Gallery extends React.Component {
  state = {
    imgSelected: null,
    imgUploaded: null,
    imgUploadedServer: null,
  }

  selectImageChange = (event) => {
    const reader = new FileReader()

    if (!event.target.files[0]) return

    if (event.target.files[0].size <= 1024 * 1024 * 2) {
      this.setState({ imgUploadedServer: event.target.files[0] })
    } else {
      return window.message.error("Tamaño máximo de 2MB.", 5)
    }

    reader.onload = () => {
      if (reader.result.includes("image")) {
        this.setState({ imgUploaded: reader.result })
      } else {
        window.message.error("Error al cargar imagen.", 5)
      }
    }

    reader.readAsDataURL(event.target.files[0])
  }

  render() {
    const { imgSelected, imgUploaded, imgUploadedServer } = this.state
    const { visible, onOk } = this.props

    return (
      <Modal
        width={780}
        visible={visible}
        title="Seleccionar imagen de fondo"
        okText="Seleccionar"
        cancelText="Cerrar"
        bodyStyle={{ padding: 0, height: 452, overflowY: "auto" }}
        onOk={() => {
          onOk(imgUploadedServer)
          this.props.setStateFrom("modalGallery", false)
          this.setState({
            imgUploaded: null,
            imgUploadedServer: null,
          })
        }}
        onCancel={() => {
          this.props.setStateFrom("modalGallery", false)
          this.setState({
            imgUploaded: null,
            imgUploadedServer: null,
          })
        }}>
        <Tabs
          defaultActiveKey="gallery"
          animated={false}
          className="container-gallery__tabs">
          <TabPane tab="Galería" key="gallery">
            <div className="container-gallery__images">
              {map(data, ({ image, id }) => {
                return (
                  <div
                    key={id}
                    className={`container-gallery__image ${
                      imgSelected === id ? "active" : ""
                    }`}
                    onClick={() => this.setState({ imgSelected: id })}>
                    {imgSelected === id && (
                      <img
                        className="tagImgIcon"
                        // src={checkBlue}
                        src={null}
                        alt="check-blue"
                      />
                    )}
                    <img className="tagImg" src={image} alt="landscapes" />
                  </div>
                )
              })}
            </div>
          </TabPane>
          <TabPane tab="Importar imagen" key="import-image">
            <div className="container-gallery__upload-image">
              {imgUploaded ? (
                <React.Fragment>
                  <div
                    className="container-gallery__remove-image"
                    onClick={() => this.setState({ imgUploaded: null })}>
                    <CloseOutlined />
                  </div>
                  <img src={imgUploaded} />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="title">
                    Selecciona la imagen que deseas utilizar como <br />
                    fondo del cuestionario
                  </div>
                  <p>Se admiten archivos en JPG y PNG. Tamaño máximo de 2MB.</p>
                  <Button onClick={() => this.selectImage.click()}>
                    Seleccionar imagen
                  </Button>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    accept="image/*"
                    onChange={this.selectImageChange}
                    ref={(selectImage) => (this.selectImage = selectImage)}
                  />
                </React.Fragment>
              )}
            </div>
          </TabPane>
        </Tabs>
      </Modal>
    )
  }
}

Gallery.propTypes = {}

export default Gallery
